import * as Yup from 'yup';

export const createCustomerFormYupValidation = () => {
  return Yup.object().shape({
    companyName: Yup.string().required('required'),
    companyEmail: Yup.string().required('required'),
    companyContact: Yup.string().required('required'),
    companyCity: Yup.string().required('required'),
    companyAddress: Yup.string().required('required'),
    companyZip: Yup.string().required('required'),
    companyUsers: Yup.array().required().min(1, 'required'),
  });
};
